define('presentation/tabs/presentationObjects/tabsPresentationObject',[],function() {
    return function(tabId, tabActive, isTabValid, tabText = null) {
        const tab = this;
        tab.id = tabId.replace(/ /g, '');
        tab.tabText = tabText != null ? tabText : tabId;
        tab.label = tab.tabText;
        tab.setTabActive = () => {
            tabActive(tab.id);
        };
        tab.isActiveTab = ko.pureComputed(() => {
            return tabActive() === tab.id;
        });
        tab.isTabValid = isTabValid;
        tab.isTabInvalid = ko.pureComputed(() => {
            return isTabValid === undefined ? false : !isTabValid();
        });
        tab.isVisible = ko.observable(true);
    };
});
